import { capitalize } from 'lodash'
import React, { FC, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { RouteComponentProps, useLocation } from 'react-router-dom'
import routes from 'src/routes'
import { setPageTitle, setPreviousPage } from '../../../ducks/onDemand'
import { ListItem } from '../AbstractList/ListItem'
import { bestClinical, bestLaboratory, caseClinical, caseLaboratory, clinicalResearch, laboratoryResearch } from '../abstracts'


const getTitle = (route) => {
  switch (route) {
    case routes.onDemandB17:
      return "Best 17 Abstracts in Research (Clinical)"
    case routes.onDemandB15:
      return "Best 15 Abstracts in Research (Laboratory)"
    case routes.onDemandClinical:
      return "Clinical Research"
    case routes.onDemandLaboratory:
      return "Laboratory Research"
    case routes.onDemandCaseClinical:
      return "Case Report / Case Series Clinical"
    case routes.onDemandCaseLaboratory:
      return "Case Report / Case Series Laboratory"
    default:
      return ""
  }
}

const getAbstract = (route) => {
  switch (route) {
    case routes.onDemandB17:
      return bestClinical
    case routes.onDemandB15:
      return bestLaboratory
    case routes.onDemandClinical:
      return clinicalResearch
    case routes.onDemandLaboratory:
      return laboratoryResearch
    case routes.onDemandCaseClinical:
      return caseClinical
    case routes.onDemandCaseLaboratory:
      return caseLaboratory
    default:
      return []
  }
}

export const BestBasicScience: FC<RouteComponentProps> = () => {
  const dispatch = useDispatch()
  const location = useLocation()

  useEffect(() => {
    dispatch(setPageTitle(getTitle(location.pathname)))
    dispatch(setPreviousPage(routes.onDemandPoster))
  }, [dispatch])

  return (
    <div className='list-container'>
      {getAbstract(location.pathname).map((poster) => {
        return <ListItem key={poster.id} abstractType={getTitle(location.pathname).includes("Case Report") ? "poster" : "audio"} title={poster.title} subtitle={capitalize(poster.presenting_author_name)} abstractId={poster.id} />
      })}
    </div>
  )
}
